// src/data/dressData.js
import images from "../images.config";
const dressData = [
  {
    "id": 1,
    "title": "Asymmetric Dress",
    "description": "An elegant asymmetric dress perfect for formal occasions.",
    "price": 11000,
    "discountedPrice": 9900,
    "rating": 4.5,
    "stock": 20,
    "brand": "Fashionista",
    "category": "trends",
    "thumbnail": images.collection1, // array of the images with the compression into the smaller sizes.
    "images": [images.collection1, images.collection3,images.collection3,images.collection1,images.collection3,images.collection2], // big images
    "sizes": ["XXS/4",  "XL/16", "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"georgette",
   
    "inStock":false,

  },
  {
    "id": 2,
    "title": "Black Keyhole Dress",
    "description": "A stylish black dress with a keyhole design.",
    "price": 10900,
    "discountedPrice": 9265,
    "rating": 4.7,
    "stock": 15,
    "brand": "StyleHub",
    "category": "dresses",
   "thumbnail": images.collection3,
    "images": [images.collection2, images.collection1,images.collection3,images.collection2,images.collection1,images.collection3,images.collection3],
    "sizes": ["XXS/4", "XS/6", , "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"silk",
    "quantity":2,
    "inStock":true,


  },
  {
    "id": 3,
    "title": "Ruffled Dress",
    "description": "A fun and flirty ruffled dress ideal for casual outings.",
    "price": 11000,
    "discountedPrice": 10450,
    "rating": 4.3,
    "stock": 30,
    "brand": "ChicWardrobe",
    "category": "dresses",
   "thumbnail": images.collection1,
    "images": [images.collection3, images.collection3,images.collection3,images.collection1,images.collection3,images.collection3],
    "sizes": ["XXS/4", "XS/6", "S/8", "M/10", "L/14",  "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"nylon",
    "quantity":1,
    "inStock":true,




  },
  {
    "id": 4,
    "title": "Floral Maxi Dress",
    "description": "A beautiful floral maxi dress perfect for summer.",
    "price": 12000,
    "discountedPrice": 11040,
    "rating": 4.6,
    "stock": 18,
    "brand": "Blossom Collection",
    "category": "trends",
    "thumbnail": images.collection1,
    "images": [images.collection2, images.collection3,images.collection3,images.collection1,images.collection3,images.collection3],
    "sizes": [ "M/10", "L/14", "XL/16", "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"cotton",
    "quantity":5,
    "inStock":false,



  },
  {
    "id": 5,
    "title": "Pleated A-Line Dress",
    "description": "An A-line pleated dress that flatters every body shape.",
    "price": 9000,
    "discountedPrice": 7920,
    "rating": 4.2,
    "stock": 22,
    "brand": "DressUp",
    "category": "trends",
   "thumbnail": images.collection1,
    "images": [images.collection1, images.collection3,images.collection3,images.collection3,images.collection3,images.collection3],
    "sizes": ["XXS/4", "XS/6", "XL/16", "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"wool",
   
    "inStock":true,


  },
  {
    "id": 6,
    "title": "Little Black Dress",
    "description": "A timeless little black dress for any occasion.",
    "price": 10500,
    "discountedPrice": 8400,
    "rating": 4.8,
    "stock": 10,
    "brand": "ClassicWear",
    "category": "dresses",
   "thumbnail": images.collection1,
    "images": [images.collection2, images.collection3,images.collection3,images.collection3,images.collection3,images.collection3],
    "sizes": ["XXS/4", "XS/6", "S/8",  "L/14", "XL/16", "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"cotton",
    "quantity":2,
"inStock":true,
  },
  {
    "id": 7,
    "title": "Red Satin Dress",
    "description": "A red satin dress that makes a bold statement.",
    "price": 13000,
    "discountedPrice": 10640,
    "rating": 4.9,
    "stock": 14,
    "brand": "GlamourGoddess",
    "category": "dresses",
   "thumbnail": images.collection1,
    "images": [images.collection1, images.collection3,images.collection3,images.collection3,images.collection3,images.collection3],
    "sizes": ["XXS/4", "S/8", "M/10", "L/14", "XL/16", "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"silk",
    "quantity":2,
    "inStock":true,


  },
  {
    "id": 8,
    "title": "Bodycon Dress",
    "description": "A sleek bodycon dress that hugs your curves.",
    "price": 8000,
    "discountedPrice": 6000,
    "rating": 4.4,
    "stock": 25,
    "brand": "SculptWear",
    "category": "dresses",
   "thumbnail": images.collection1,
    "images": [images.collection2, images.collection3,images.collection3,images.collection3,images.collection3,images.collection3],
    "sizes": [ "XS/6", "S/8", "M/10", "L/14", "XL/16", "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"wool",
    "quantity":2,
    "inStock":false,


  },
  {
    "id": 9,
    "title": "Casual Denim Dress",
    "description": "A cool denim dress for casual, everyday wear.",
    "price": 9500,
    "discountedPrice": 8550,
    "rating": 4.6,
    "stock": 12,
    "brand": "UrbanTrends",
    "category": "trends",
   "thumbnail": images.collection1,
    "images": [images.collection2, images.collection3,images.collection3,images.collection3,images.collection3,images.collection3,images.collection3],
    "sizes": ["XXS/4", "XS/6",  "M/10", "L/14", "XL/16", "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"georgette",
    "quantity":2,
    "inStock":true,


  },
  {
    "id": 10,
    "title": "Peplum Dress",
    "description": "A peplum dress with a flattering waistline.",
    "price": 11500,
    "discountedPrice": 10350,
    "rating": 4.5,
    "stock": 16,
    "brand": "ChicWear",
    "category": "dresses",
    "thumbnail": images.collection1,
    "images": [images.collection2, images.collection3,images.collection3,images.collection3,images.collection3,images.collection3],
    "sizes": ["XXS/4", "S/8", "M/10", "L/14", "XL/16", "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"cotton",
    "quantity":2,
    "inStock":true,

  },
  {
    "id": 11,
    "title": "Lace Dress",
    "description": "A beautiful lace dress perfect for a romantic date.",
    "price": 14000,
    "discountedPrice": 12800,
    "rating": 4.3,
    "stock": 14,
    "brand": "LuxeFashion",
    "category": "dresses",
   "thumbnail": images.collection1,
    "images": [images.collection2, images.collection3,images.collection3,images.collection3,images.collection3,images.collection3],
    "sizes": ["XXS/4", "XS/6", "M/10", "L/14", "XL/16", "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"cotton",
    "quantity":2,
    "inStock":true,


  },
  {
    "id": 12,
    "title": "Maxi Dress",
    "description": "A flowing maxi dress for a relaxed and elegant look.",
    "price": 12000,
    "discountedPrice": 10560,
    "rating": 4.6,
    "stock": 19,
    "brand": "Glamour Boutique",
    "category": "trends",
    "thumbnail": images.collection1,
    "images": [images.collection2, images.collection3,images.collection3,images.collection3,images.collection3,images.collection3],
    "sizes": ["XXS/4", "XS/6", "M/10", "L/14", "XL/16", "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"cotton",
    "quantity":2,
    "inStock":true,

  },
  {
    "id": 13,
    "title": "Asymmetric Dress",
    "description": "An elegant asymmetric dress perfect for formal occasions.",
    "price": 11000,
    "discountedPrice": 9900,
    "rating": 4.5,
    "stock": 20,
    "brand": "Fashionista",
    "category": "trends",
    "thumbnail": images.collection1,
    "images": [images.collection1, images.collection3,images.collection3,images.collection1,images.collection3,images.collection2],
    "sizes": ["XXS/4",  "XL/16", "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"georgette",
    "quantity":2,
    "inStock":true,

  },
  {
    "id":  14,
    "title": "Black Keyhole Dress",
    "description": "A stylish black dress with a keyhole design.",
    "price": 10900,
    "discountedPrice": 9265,
    "rating": 4.7,
    "stock": 15,
    "brand": "StyleHub",
    "category": "dresses",
   "thumbnail": images.collection3,
    "images": [images.collection2, images.collection1,images.collection3,images.collection2,images.collection1,images.collection3,images.collection3],
    "sizes": ["XXS/4", "XS/6", , "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"silk",
    "quantity":2,
    "inStock":true,


  },
  {
    "id": 15,
    "title": "Ruffled Dress",
    "description": "A fun and flirty ruffled dress ideal for casual outings.",
    "price": 11000,
    "discountedPrice": 10450,
    "rating": 4.3,
    "stock": 30,
    "brand": "ChicWardrobe",
    "category": "dresses",
   "thumbnail": images.collection1,
    "images": [images.collection3, images.collection3,images.collection3,images.collection1,images.collection3,images.collection3],
    "sizes": ["XXS/4", "XS/6", "S/8", "M/10", "L/14",  "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"nylon",
    "quantity":2,
    "inStock":true,


  },
  {
    "id": 16,
    "title": "Floral Maxi Dress",
    "description": "A beautiful floral maxi dress perfect for summer.",
    "price": 12000,
    "discountedPrice": 11040,
    "rating": 4.6,
    "stock": 18,
    "brand": "Blossom Collection",
    "category": "trends",
    "thumbnail": images.collection1,
    "images": [images.collection2, images.collection3,images.collection3,images.collection1,images.collection3,images.collection3],
    "sizes": [ "M/10", "L/14", "XL/16", "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"cotton",
    "quantity":2,
    "inStock":true,

  },
  {
    "id": 17,
    "title": "Pleated A-Line Dress",
    "description": "An A-line pleated dress that flatters every body shape.",
    "price": 9000,
    "discountedPrice": 7920,
    "rating": 4.2,
    "stock": 22,
    "brand": "DressUp",
    "category": "trends",
   "thumbnail": images.collection1,
    "images": [images.collection1, images.collection3,images.collection3,images.collection3,images.collection3,images.collection3],
    "sizes": ["XXS/4", "XS/6", "XL/16", "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"wool",
    "quantity":2,
    "inStock":true,

  },
  {
    "id": 18,
    "title": "Little Black Dress",
    "description": "A timeless little black dress for any occasion.",
    "price": 10500,
    "discountedPrice": 8400,
    "rating": 4.8,
    "stock": 10,
    "brand": "ClassicWear",
    "category": "dresses",
   "thumbnail": images.collection1,
    "images": [images.collection2, images.collection3,images.collection3,images.collection3,images.collection3,images.collection3],
    "sizes": ["XXS/4", "XS/6", "S/8",  "L/14", "XL/16", "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "quantity":2,
    "material":"cotton",
    "inStock":true,

  },
  {
    "id": 19,
    "title": "Red Satin Dress",
    "description": "A red satin dress that makes a bold statement.",
    "price": 13000,
    "discountedPrice": 10640,
    "rating": 4.9,
    "stock": 14,
    "brand": "GlamourGoddess",
    "category": "dresses",
   "thumbnail": images.collection1,
    "images": [images.collection1, images.collection3,images.collection3,images.collection3,images.collection3,images.collection3],
    "sizes": ["XXS/4", "S/8", "M/10", "L/14", "XL/16", "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"silk",
    "quantity":2,
    "inStock":true,

  },
  {
    "id": 20,
    "title": "Bodycon Dress",
    "description": "A sleek bodycon dress that hugs your curves.",
    "price": 8000,
    "discountedPrice": 6000,
    "rating": 4.4,
    "stock": 25,
    "brand": "SculptWear",
    "category": "dresses",
   "thumbnail": images.collection1,
    "images": [images.collection2, images.collection3,images.collection3,images.collection3,images.collection3,images.collection3],
    "sizes": [ "XS/6", "S/8", "M/10", "L/14", "XL/16", "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"wool",
    "quantity":2,
    "inStock":true,


  },
  {
    "id": 21,
    "title": "Casual Denim Dress",
    "description": "A cool denim dress for casual, everyday wear.",
    "price": 9500,
    "discountedPrice": 8550,
    "rating": 4.6,
    "stock": 12,
    "brand": "UrbanTrends",
    "category": "trends",
   "thumbnail": images.collection1,
    "images": [images.collection2, images.collection3,images.collection3,images.collection3,images.collection3,images.collection3,images.collection3],
    "sizes": ["XXS/4", "XS/6",  "M/10", "L/14", "XL/16", "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"georgette",
    "quantity":2,
    "inStock":true,


  },
  {
    "id": 22,
    "title": "Peplum Dress",
    "description": "A peplum dress with a flattering waistline.",
    "price": 11500,
    "discountedPrice": 10350,
    "rating": 4.5,
    "stock": 16,
    "brand": "ChicWear",
    "category": "dresses",
    "thumbnail": images.collection1,
    "images": [images.collection2, images.collection3,images.collection3,images.collection3,images.collection3,images.collection3],
    "sizes": ["XXS/4", "S/8", "M/10", "L/14", "XL/16", "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "quantity":2,
    "material":"cotton",
    "inStock":true,

  },
  {
    "id": 23,
    "title": "Lace Dress",
    "description": "A beautiful lace dress perfect for a romantic date.",
    "price": 14000,
    "discountedPrice": 12800,
    "rating": 4.3,
    "stock": 14,
    "brand": "LuxeFashion",
    "category": "dresses",
   "thumbnail": images.collection1,
    "images": [images.collection2, images.collection3,images.collection3,images.collection3,images.collection3,images.collection3],
    "sizes": ["XXS/4", "XS/6", "M/10", "L/14", "XL/16", "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"cotton",
    "quantity":2,
    "inStock":false,


  },
  {
    "id": 24,
    "title": "Maxi Dress",
    "description": "A flowing maxi dress for a relaxed and elegant look.",
    "price": 12000,
    "discountedPrice": 10560,
    "rating": 4.6,
    "stock": 19,
    "brand": "Glamour Boutique",
    "category": "trends",
    "thumbnail": images.collection1,
    "images": [images.collection2, images.collection3,images.collection3,images.collection3,images.collection3,images.collection3],
    "sizes": ["XXS/4", "XS/6", "M/10", "L/14", "XL/16", "XXL/18"],
    "colors": ["bg-primary1", "bg-review", "bg-hcolor"],
    "material":"cotton",
    "quantity":2,
    "inStock":true,

  }
  // Add more items here...
];

export default dressData;
